import {Component, OnInit} from '@angular/core';
import {PolicyService} from "../../../api/services/policy.service";
import {PolicyManager} from "../../../api/models/policy-manager";

@Component({
  selector: 'app-policy-manager',
  templateUrl: './policy-manager.component.html',
  styleUrls: ['./policy-manager.component.css']
})
export class PolicyManagerComponent implements OnInit {

  policies = [] as PolicyManager[];

  constructor(private _policyService: PolicyService) {
    this.loadThePolicies()
  }

  private loadThePolicies() {
    this.policies = [];
    this._policyService.getPoliciesByEntityNameOrBlockedOnly({blockedOnly: null, entityName: null}).subscribe({
      next: data => {
        this.policies = data.filter(t => t.detectedViolation != undefined && t.allowSkipping == false) as any;
        },
      error: err => {
      },
      complete: () => {
      }
    });
  }

  ngOnInit(): void {
  }

  skipTheEntity(conical: string) {
    this._policyService.flushPolicy(conical).subscribe({
      next: data => {
        if (data){
          this.loadThePolicies();
        }
      }
    });
  }
}
